/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPaymentMethodStatusResult } from '../../models/get-payment-method-status-result';

export interface ApiBillingPaymentMethodStatusGet$Params {

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiBillingPaymentMethodStatusGet(http: HttpClient, rootUrl: string, params?: ApiBillingPaymentMethodStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPaymentMethodStatusResult>> {
  const rb = new RequestBuilder(rootUrl, apiBillingPaymentMethodStatusGet.PATH, 'get');
  if (params) {
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPaymentMethodStatusResult>;
    })
  );
}

apiBillingPaymentMethodStatusGet.PATH = '/api/Billing/payment-method/status';
